<template>
  <div class="c-form-popup-wrap" v-show="showForm == true">
    <div class="c-form-popup-header">
      <div class="c-form-popup-close" v-on:click="showForm = false">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
          <path fill="none" d="M0 0h32v32H0z"/>
          <path d="M16.2 15.5l5.1-5.1c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-5.1 5.1-5.1-5.1c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l5.1 5.1-5.1 5.1c-.2.2-.2.5 0 .7.1.1.2.1.4.1.1 0 .3 0 .4-.1l5.1-5.1 5.1 5.1c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7l-5.3-5.1z"/>
        </svg>
      </div>
      <h2>{{dataCar.data.car.brand_name}} {{dataCar.data.car.model_name}}</h2>
    </div>
    <div class="c-form-popup-container">
      <div class="c-carDesc-img">
        <img style="max-width:100%;" :src="'https://webapi.piamarket.pl/img/' + dataCar.data.car.id+ '/' + dataCar.data.car.photos[0] +'-xlg.jpg'"alt="">
      </div>
      <div class="c-carDesc-text">
        <div class="c-carDesc-text-item">
          <p>
            <strong>Informacje podstawowe</strong>
          </p>
          <ul>
            <li>Pojemność silnika: {{dataCar.data.car.capacity}}</li>
            <li>Rodzaj nadwozia: {{dataCar.data.car.body}}</li>
            <li>Skrzynia biegów: {{dataCar.data.car.transmission}}</li>
            <li>Rodzaj paliwa: {{dataCar.data.car.fuel}}</li>
            <li>Przebieg: {{dataCar.data.car.mileage}}</li>
            <li>Rodzaj napędu: {{dataCar.data.car.drive}}</li>
            <li>Liczba drzwi: {{dataCar.data.car.doors}}</li>
            <li>Liczba miejsc: {{dataCar.data.car.seats}}</li>
            <li>Kolor: {{dataCar.data.car.color}}</li>
            <li>Rok produkcji: {{dataCar.data.car.production_year}}</li>
          </ul>
        </div>
        <div class="c-carDesc-text-item">
          <p>
            <strong>Osiągi</strong>
          </p>
          <ul>
            <li>Moc: {{dataCar.data.car.power}} KM</li>
            <li>Prędkość maksymalna: {{dataCar.data.car.top_speed}} km/h</li>
            <li>Przyspieszenie [0-100km/h]: {{dataCar.data.car.accel}} s</li>
          </ul>
        </div>
        <div class="c-carDesc-text-item">
          <p>
            <strong>Wymiary</strong>
          </p>
          <ul>
            <li>Szerokość: {{dataCar.data.car.width}} mm</li>
            <li>Wysokość: {{dataCar.data.car.height}} mm</li>
            <li>Długość: {{dataCar.data.car.length}} mm</li>
            <li>Rozstaw osi: {{dataCar.data.car.wheelbase}} mm</li>
            <li>Masa własna: {{dataCar.data.car.weight_own}} kg</li>
            <li>Masa całkowita: {{dataCar.data.car.weight_total}} kg</li>
          </ul>
        </div>
        <div class="c-carDesc-text-item">
          <p>
            <strong>Wyposażenie podstawowe</strong>
          </p>
          <ul>
            <li v-for="eurotax in dataCar.data.car.eurotax[1]">{{eurotax}}</li>
          </ul>
        </div>
        <div v-if="dataCar.data.car.eurotax[2].length <= 0" class="c-carDesc-text-item">
          <p>
            <strong>Wyposażenie dodatkowe</strong>
          </p>
          <ul>
            <li v-for="eurotax in dataCar.data.car.eurotax[2]">{{eurotax}}</li>
          </ul>
        </div>
        <div class="c-carDesc-text-item">
          <p>
            <strong>Bezpieczeństwo</strong>
          </p>
          <ul>
            <li v-for="safety in dataCar.data.car.safety">{{safety}}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="c-form-popup-footer">
      <button class="c-form-popup-more" v-on:click="scrolltoForm(dataCar.data.car.id)">
        Zapytaj o ten model
      </button>
    </div>
  </div>
</template>
<!-- <template>
<div class="c-form-popup-wrap" v-show="showForm == true">
<div class="c-form-popup-container">
<div class="c-form-popup-close" v-on:click="showForm = false">
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
<path fill="none" d="M0 0h32v32H0z"/>
<path d="M16.2 15.5l5.1-5.1c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-5.1 5.1-5.1-5.1c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l5.1 5.1-5.1 5.1c-.2.2-.2.5 0 .7.1.1.2.1.4.1.1 0 .3 0 .4-.1l5.1-5.1 5.1 5.1c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7l-5.3-5.1z"/>
</svg>
</div>
<h2>Formularz kontaktowy</h2>
<h5>
Jeżeli chcesz otrzymać ofertę na wybrany samochód, wypełnij i wyślij formularz kontaktowy. Zadzwonimy do Ciebie, aby przygotować indywidualną ofertę.
</h5>
<div v-html="formHtml">

</div>
</div>
</div>
</template> -->

<script>
var mylib = require('../form-validate-vanilla')
export default {
  name: 'Form',
  props: [
    'showForm',
    'NumberOffer'
  ],
  data: function () {
    return {
      // formUrl: 'http://audisosnowiec.pl/include/formularz-wyszukiwarka-samochodow-nowych.php',
      formHtml: '...',
      dataCar: ''
    }
  },
  methods: {
    getForm: function () {
      // this.axios.get(this.formUrl).then((response) => {
      //   this.formHtml = response.data
      // })

    },
    scrolltoForm: function (numer) {
      document.querySelector('textarea').innerHTML = 'Zainteresowany ofertą o numerze: '+numer;
      var elmnt = document.getElementById("c-formhtml");
      setTimeout(function(){
        elmnt.scrollIntoView();
      }, 100)
      this.showForm = false

    }
  },
  watch: {
    showForm: function (val) {
      this.$emit('ShowForm', val)
      if (val === true) {
        gtag('event', 'Wyświetlanie', {
          'event_category': 'Szczegóły',
          'event_label': 'Wyświetlenie szczegółów',
          'value': '1'
        })
      }
    },
    NumberOffer: function(val){
      this.axios.get('https://webapi.piamarket.pl/car?id='+val)
      .then(response => (
        this.dataCar = response
      ))
    }
  },
  mounted: function () {
    this.getForm()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.background-box {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.c-carDesc{
  &-text {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    &-item {
      width: 100%;
      @media (min-width: 768px) {
        width: 32%;
      }
    }
  }
}
.c-form-popup{
  &-wrap{
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, .75);
  }
  &-header{
    position: relative;
    background-color: #fff;
    max-width: 960px;
    max-height: 10vh;
    // overflow: auto;
    margin: 0 auto;
    margin-top: 1rem;
    padding: 1rem 2rem;
    border-bottom: 1px solid #777;
    h2{
      font-size: 2.5rem;
      margin: 0;
    }
  }
  &-container{
    position: relative;
    background-color: #fff;
    max-width: 960px;
    height: 82vh;
    overflow: auto;
    margin: 0 auto;
    padding: 2rem;
    h5{
      font-size: 1rem;
    }
  }
  &-footer{
    position: relative;
    background-color: #fff;
    max-width: 960px;
    max-height: 10vh;
    // overflow: auto;
    margin: 0 auto;
    padding: 1rem 2rem;
    border-top: 1px solid #777;
  }
  &-close{
    position: absolute;
    top: 2rem;
    right: 2rem;
    width: 25px;
    height: 25px;
    background-color: #000;
    cursor: pointer;
    svg{
      fill: #fff;
    }
  }
  &-more{
        background: #af022d;
        padding: 1rem 3rem;
        border: 0;
        color: #fff;
        font-weight: bold;
        cursor: pointer;

  }
}
.c-carDesc-text{
  justify-content: flex-start;
}
</style>
